import { v4 as uuidv4 } from 'uuid';

import { fetchAddresses } from 'APIPackage/KnmModule/services/knmAddressesApi';
import { findRegionSelectOption } from 'KnmPackage/MainModule/components/regions';

import { IKnmErknmFormObject } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { IErvkObjectsOfControl } from '../../../APIPackage/KnmModule/interfaces/IErvkObjectsOfControl';
import { IDictionarySelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IDangerClass248 } from '../../../APIPackage/DictionariesModule/interfaces/IDangerClass248';
import { ISubjectKind } from '../../../APIPackage/DictionariesModule/interfaces/ISubjectKind';
import { ISubjectType } from '../../../APIPackage/DictionariesModule/interfaces/ISubjectType';
import { IRiskCategory248 } from '../../../APIPackage/DictionariesModule/interfaces/IRiskCategory248';
import { IKnmDistrictSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';

const fetchAddressesOrEmpty = async (address: string) => fetchAddresses({ query: address }).catch(() => [] as string[]);

export const isAddressInFias = async (address: string) => {
  if (!address) return false;

  const allOptions = await fetchAddressesOrEmpty(address);

  return allOptions.includes(address);
};

export async function addErvkObject(
  object: IErvkObjectsOfControl,
  organizationErvkId: string | undefined,
  dangerClassesSelectOptions: IDictionarySelectOption<IDangerClass248>[] | undefined,
  objectKindsSelectOptions: IDictionarySelectOption<ISubjectKind>[] | undefined,
  objectSubKindsSelectOptions: IDictionarySelectOption<ISubjectKind>[] | undefined,
  objectTypesSelectOptions: IDictionarySelectOption<ISubjectType>[] | undefined,
  riskCategoriesSelectOptions: IDictionarySelectOption<IRiskCategory248>[] | undefined,
  districtSelectOptions: IKnmDistrictSelectOption[] | undefined,
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  push: ((...args: any[]) => any) | undefined,
  fieldName: string,
  fieldValueIndex?: number,
) {
  if (push) {
    const objectKind = objectKindsSelectOptions?.find(x => x.title === object.objectKind?.title);
    const objectSubKind = objectKind?.analogue
      ? objectKind
      : objectSubKindsSelectOptions?.find(x =>
          object.objectSubKind?.code ? x.code === object.objectSubKind?.code : x.title === object.objectSubKind?.title,
        );

    const isNotInFIAS = !object.locationIsFromFias;
    // regionCode это регион осуществления контроля, а не местоположения объекта, в поиск не берем
    const searchId = object.locationRegionFiasUuid || object.locationRegionCode;
    const objectAddress = object.address || object.geolocation;

    const objectFiasRegion = await findRegionSelectOption(objectAddress, searchId || undefined, districtSelectOptions);

    const objectRegionName = object.region ?? objectFiasRegion?.name;

    const addingObject: IKnmErknmFormObject = {
      // Адрес живет ровно в одной ветке, ее выбирает notInFIAS
      address: isNotInFIAS ? undefined : objectAddress,
      addressFns: undefined,
      autocomplete: undefined,
      dangerClass: dangerClassesSelectOptions?.find(x => x.title === object.dangerClass?.title),
      dateCreate: undefined,
      ervkId: object.ervkId,
      ervkNumber: object.ervkNumber,
      cosId: object.cosId,
      cosVersion: object.cosVersion,
      fiasRegion: objectFiasRegion,
      geolocation: object.geolocation,
      guid: undefined,
      houseGuid: undefined,
      inspectionResults: undefined,
      isErrorFiasValue: undefined,
      isNew: true,
      listId: uuidv4(),
      manualAddress: isNotInFIAS ? objectAddress : undefined,
      name: object.name,
      notInFIAS: isNotInFIAS,
      objectKind,
      objectSubKind,
      objectType: objectTypesSelectOptions?.find(x => x.code === object.objectType?.code),
      organizationErvkId: organizationErvkId ? [organizationErvkId] : undefined,
      region: objectFiasRegion || undefined,
      regionName: object.region || objectRegionName || undefined,
      riskCategory: riskCategoriesSelectOptions?.find(x => x.title === object.risk?.title),
      roomGuid: undefined,
      steadGuid: undefined,
      streetGuid: undefined,
      updating: undefined,
    };

    if (fieldValueIndex !== undefined) {
      push(fieldName, fieldValueIndex, addingObject);
    } else {
      push(fieldName, addingObject);
    }
  }
}
